import { render, staticRenderFns } from "./FindingEscalationGroups.vue?vue&type=template&id=70c2519a"
import script from "./FindingEscalationGroups.vue?vue&type=script&lang=ts"
export * from "./FindingEscalationGroups.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports